import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './Processing.module.scss.js';

var overlayFadeEnterTimeout = 200;
var overlayFadeLeaveTimeout = 200;
var Processing = function (_a) {
    var label = _a.label, isFetching = _a.isFetching, isInside = _a.isInside, useSpinner = _a.useSpinner, className = _a.className;
    var _b = React.useState(isFetching), inProp = _b[0], setInProp = _b[1];
    var nodeRef = React.useRef(null);
    React.useEffect(function () {
        setInProp(!!isFetching);
    }, [isFetching]);
    var render = function () {
        var _a;
        if (useSpinner) {
            return (jsx("div", { ref: nodeRef, className: classNames(styles.processingSpinner, className), children: jsxs("div", { className: styles.processingSpinnerInner, children: [jsx("div", { className: styles.processingSpinnerIcon }), jsx("div", { className: styles.processingSpinnerText, children: label })] }) }, "loader"));
        }
        else {
            return (jsxs("div", { ref: nodeRef, className: classNames((_a = {},
                    _a[styles.processingInside] = !!isInside,
                    _a[styles.processing] = !isInside,
                    _a), className), children: [jsx("div", { className: styles.spinner }), !!label ? jsx("div", { className: styles.label, children: label }) : null] }, "spinner"));
        }
    };
    return (jsx(CSSTransition, { classNames: "overlay-fade", nodeRef: nodeRef, in: inProp, timeout: { enter: overlayFadeEnterTimeout, exit: overlayFadeLeaveTimeout }, children: isFetching ? render() : jsx(Fragment, {}) }));
};

export { Processing as default };
//# sourceMappingURL=Processing.js.map
